import React, { useEffect, useState } from 'react';
import { assoc, compose, equals, gt, length, prop, not, isNil, defaultTo, mergeRight, filter } from 'ramda';
import { notEqual } from 'ramda-adjunct';
import { PAGE_SIZE_OPTIONS } from '../_CONST';

const position = 'bottomCenter';
const defaultPageSize = 5;
const current = 1;
const totalBoundaryShowSizeChanger = 5;

const getPageSizePreference = (pageKey, pageSize) => {
  const value = sessionStorage.getItem('pageSizePreference');
  const parsedValue = JSON.parse(value);
  if (isNil(pageKey)) return parsedValue || pageSize;
  return prop(pageKey, parsedValue);
};

const setPageSizePreference = (pageKey, pageSize) => {
  let pageSizePreference = getPageSizePreference();
  const withDefaults = mergeRight(pageSizePreference);
  pageSizePreference = withDefaults({ [pageKey]: pageSize });

  sessionStorage.setItem('pageSizePreference', JSON.stringify(pageSizePreference));
};

const usePagination = ({ itemsNumber, type, pageSizeKey, offerId, pageSize = defaultPageSize }) => {
  let preferredPageSize = isNil(pageSizeKey) ? null : getPageSizePreference(pageSizeKey, pageSize);
  preferredPageSize = defaultTo(pageSize)(preferredPageSize);

  const showTotal = (total) => equals(type, 'frame') && <span className="mr-2">Total de {total} trame{gt(total, 1) ? 's' : ''}</span>;

  const [pagination, setPagination] = useState({
    position, current, pageSize: preferredPageSize, totalBoundaryShowSizeChanger, defaultPageSize: pageSize, pageSizeOptions: PAGE_SIZE_OPTIONS, total: itemsNumber, showTotal, offerId
  });

  const onChangePagination = (pagination, extra) => {
    const currentDataSource = prop('currentDataSource', extra);
    const totalItems = length(currentDataSource);
    const pageSizeOptions = filter(option => option < totalItems)(PAGE_SIZE_OPTIONS);
    const pageSize = prop('pageSize', pagination);

    setPagination(
      compose(
        assoc('pageSizeOptions', pageSizeOptions),
        assoc('total', totalItems),
        assoc('pageSize', pageSize),
        assoc('current', prop('current', pagination))
      )
    );

    if (not(isNil(pageSizeKey))) setPageSizePreference(pageSizeKey, pageSize);
  };

  // To update the total number of elements used for pagination
  useEffect(() => {
    const isDifferentOffer = notEqual(offerId, prop('offerId', pagination));
    const current = isDifferentOffer ? 1 : prop('current', pagination);
    setPagination({
      ...pagination, total: itemsNumber, current, offerId
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemsNumber, offerId]);

  return { pagination, onChangePagination };
};

export default usePagination;
